import { useAuth } from 'AurionCR/components';
import { AppUser } from 'services/account';

export const useCurrentUser = () => {
  return useAuth().user as AppUser;
};
